(function () {
  var auctionHandles = new Set(['maglia-originale-e-autografata-campionato-arancione-de-gennaro-copia', 'maglia-indossata-e-autografata-adigwe', 'maglia-indossata-e-autografata-zhu']);
  var registry = document.getElementById('imoco-auction-products');
  try { JSON.parse(registry ? registry.textContent : '[]').forEach(function(handle) { auctionHandles.add(handle); }); } catch (error) { /* Existing legacy recognition remains available. */ }
  var printHandles = ['maglia-campionato-blu-2026-2027', 'maglia-campionato-gialla-2025-2026-copia'];
  var checks = new Map();
  function markCard(card, title, auction) {
    card.classList.add(auction ? 'imoco-app-auction' : 'imoco-app-custom-shirt');
    if (card.querySelector('.imoco-auction-link, .imoco-shirt-link')) return;
    var link = document.createElement('a');
    link.className = 'button ' + (auction ? 'imoco-auction-link' : 'imoco-shirt-link');
    link.href = title.href;
    link.textContent = auction ? 'Vai all’asta' : 'Scegli la maglia';
    card.appendChild(link);
  }
  function checkTags(handle) {
    if (!checks.has(handle)) {
      var base = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      checks.set(handle, fetch(base + 'products/' + encodeURIComponent(handle) + '.js', {credentials:'same-origin'})
        .then(function(response) { return response.ok ? response.json() : null; })
        .then(function(product) {
          var tags = product && product.tags;
          if (typeof tags === 'string') tags = tags.split(',');
          var auction = Array.isArray(tags) && tags.some(function(tag) { return ['asta', 'aste', 'on_auction', 'wk_auction', 'upcoming_auction', 'active_bidding'].includes(tag.trim().toLowerCase()); });
          if (auction) auctionHandles.add(handle);
          return !!auction;
        }).catch(function() { return false; }));
    }
    return checks.get(handle);
  }
  function fixCards() {
    document.querySelectorAll('[data-essential-upsell-element="product"]').forEach(function(card) {
      var title = card.querySelector('a[data-essential-upsell-element="title"]');
      if (!title) return;
      var url;
      try { url = new URL(title.href); } catch (error) { return; }
      if (url.origin !== window.location.origin) return;
      var handle = url.pathname.split('/').filter(Boolean).pop();
      var auction = auctionHandles.has(handle) || /^maglia-indossata-e-autografata-/.test(handle);
      if (auction) { markCard(card, title, true); return; }
      if (printHandles.includes(handle)) { markCard(card, title, false); return; }
      if (card.dataset.imocoAuctionChecked === handle) return;
      card.dataset.imocoAuctionChecked = handle;
      card.classList.add('imoco-app-auction-pending');
      checkTags(handle).then(function(isAuction) {
        card.classList.remove('imoco-app-auction-pending');
        if (isAuction && card.dataset.imocoAuctionChecked === handle) markCard(card, title, true);
      });
    });
  }
  var scheduled = false;
  new MutationObserver(function() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function() { scheduled = false; fixCards(); });
  }).observe(document.body, {childList:true, subtree:true});
  fixCards();
}());
